var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout", { attrs: { "no-sidebar": true } }, [
    _c("div", { staticClass: "page-header" }, [
      _c("h1", [_c("small", [_vm._v("New Integration System")])])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-sm-9 col-sm-offset-1" },
      [
        _c("div", { staticClass: "text-right margin-bottom-2x" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: { disabled: _vm.processing },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              }
            },
            [
              _vm.processing
                ? _c("span", [
                    _c("i", { staticClass: "fa fa-spinner fa-spin fa-fw" }),
                    _vm._v(" SAVING...")
                  ])
                : _c("span", [_vm._v("SAVE")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("form-fields", { attrs: { form: _vm.form, errors: _vm.errors } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e77d4476", { render: render, staticRenderFns: staticRenderFns })
  }
}